import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Modal from './Modal';
import { Button } from '../../styles/common/Button.styled';
import { ConsoleInput, ConsoleLabel } from '../../styles/common/input.styled';
import KeypadSelector from './KeypadSelector';

interface KeypadModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (value: string, ingressPath?: string) => void;
  disabledKeys?: string[];
}

const Fields = styled.div`
  display: flex; flex-direction: column; gap: 20px; padding: 4px 0 8px;
`;
const PathField = styled(ConsoleLabel)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const KeypadModal: React.FC<KeypadModalProps> = ({ isOpen, onClose, onSelect, disabledKeys = [] }) => {
  const [key, setKey] = useState<string | null>(null);
  const [path, setPath] = useState('');

  useEffect(() => {
    if (!isOpen) return;
    setKey(null);
    setPath('');
  }, [isOpen]);

  if (!isOpen) return null;

  const apply = () => {
    if (!key) return;
    onSelect(key, path.trim() || undefined);
  };

  return (
    <Modal title="ARS 분기 설정" onClose={onClose} width={360} historyMode="none" footer={<><Button $variant="secondary" onClick={onClose}>취소</Button><Button $variant="primary" onClick={apply} disabled={!key}>분기 적용</Button></>}>
      <Fields data-testid="keypad-modal-fields">
        <KeypadSelector value={key} onChange={setKey} disabledKeys={disabledKeys} />
        <PathField htmlFor="ingress-path-modal">유입경로<ConsoleInput id="ingress-path-modal" value={path} maxLength={10} onChange={event => setPath(event.target.value)} placeholder="선택 입력 · 최대 10자" /></PathField>
      </Fields>
    </Modal>
  );
};

export default KeypadModal;
